import { getApiClient } from '@front/repository/common/apiClient';
import { DomainV2 } from 'troppus-common/domain';
import type { IAdminRepository as I } from './interface';

import ImportTask = DomainV2.Import.ImportTask;

/**
 * Admin API のエラー。サーバの AppError レスポンス（errorCode.id など）を front 側で
 * 判別できるようにするためのクラス。
 */
export class AdminApiError extends Error {
  readonly errorCodeId?: string;
  readonly details?: unknown;

  constructor(message: string, errorCodeId?: string, details?: unknown) {
    super(message);
    this.name = 'AdminApiError';
    this.errorCodeId = errorCodeId;
    this.details = details;
  }
}

// AppError レスポンスの形（apps/troppus/packages/api/src/app.ts errorHandler 参照）
type AppErrorBody = {
  name?: string;
  message?: string;
  errorCode?: { id?: string; httpStatus?: number; message?: string };
  details?: unknown;
};

const toAdminApiError = (resError: unknown, fallbackMessage: string): AdminApiError => {
  const body = (resError ?? {}) as AppErrorBody;
  const message = body.errorCode?.message ?? body.message ?? fallbackMessage;
  return new AdminApiError(message, body.errorCode?.id, body.details);
};

export class AdminRepository implements I {
  forceFinishImportTask: I.ForceFinishImportTask = async ({ projectId, importTaskId }, options) => {
    const res = await getApiClient().POST('/admin/import-task/force-finish', {
      body: { projectId, importTaskId },
      signal: options?.signal,
    });
    if (!res.data) throw toAdminApiError(res.error, 'Failed to force-finish import task');
    return { importTaskId: ImportTask.Id.FromString(res.data.importTaskId) };
  };

  forceRemoveImportTableDefinition: I.ForceRemoveImportTableDefinition = async ({ projectId, id }, options) => {
    const res = await getApiClient().POST('/admin/import-table-definition/force-remove', {
      body: { projectId, id },
      signal: options?.signal,
    });
    if (!res.data) throw toAdminApiError(res.error, 'Failed to force-remove import table definition');
    return {
      forceFinishedTaskIds: res.data.forceFinishedTaskIds.map((v) => ImportTask.Id.FromString(v)),
    };
  };
}
